import { Component } from '@angular/core';
import { CommonService } from '../../core/services/common.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { InitialsPipe } from '../../../shared/pipes/initial.pipe';
import { ContentMapperService } from '../../core/services/content-mapper-service';
import { Router } from '@angular/router';
import user_endpoint from '../../data/api-endpoint/user-endpoint';
import Cookie from 'js-cookie';
@Component({
  selector: 'app-header-component',
  imports: [CommonModule, InitialsPipe,],
  templateUrl: './header-component.html',
  styleUrl: './header-component.scss'
})
export class HeaderComponent {

  toggleSideBar: boolean = true;
  isDropdownOpen: boolean = false;
  private toggleBarSubscription = new Subscription()
  userData: any = {}

  constructor(private _commonService: CommonService, private _contentMapper: ContentMapperService, private _router: Router) {

  }

  ngOnInit() {
    this.toggleBarSubscription = this._commonService.$sidebarToggle.subscribe((value: boolean) => {
      this.toggleSideBar = value
    })

    if(!localStorage.getItem('user') || localStorage.getItem('user') !== 'true'){
      this.fetchUserDetail();
    }else{
      this.userData = JSON.parse(localStorage.getItem('user_detail') || '{}');
    }

  
  }


  ngOnDestroy() {
    if (this.toggleBarSubscription) {
      this.toggleBarSubscription.unsubscribe();
    }
  
  }


  fetchUserDetail() {
    this._contentMapper.get(user_endpoint.currentUserDetail).subscribe({
      next: (response: any) => {
        this.userData = response.results;
        localStorage.setItem('user',JSON.stringify(true));
        localStorage.setItem('user_detail',JSON.stringify(response.results));
        this._commonService.updateUserDetail(response.results);
      },
      error:(error:any)=>{
        console.error('Error occured while fetching user detail', error.message);
      }
    });
  }

  logoutUser() {
    this._contentMapper.get('auth/logout').subscribe({
      next: (_: any) => {
        localStorage.removeItem('user');
        localStorage.removeItem('user_detail');
        Cookie.remove('ttd-session');
        this._router.navigate(['/login']);
      }, error: (error) => {
        console.error('Error occured while logging out', error.message);
      }
    }
    )
  }

  onImageError(event: any) {
    event.target.style.display = 'none';
    const avatar = event.target.parentElement;
    const initialsSpan = avatar.querySelector('span');
    if (initialsSpan) {
      initialsSpan.style.display = 'flex';
    }
  }

}
